import { useEffect, useState } from 'react';
import type { CreateActionContext } from 'App/components/AppSidebar/useAddActions';

type RouteContext = { type: 'company' | 'contact'; id: number };

function readRouteContext(): RouteContext | null {
	const name: string | undefined = Tools.$state?.current?.name;
	const id = Number(Tools.$stateParams?.id);
	if (!name || !id) {
		return null;
	}
	if (name === 'react-root-clientCard' || name === 'account' || name.startsWith('account.')) {
		return { type: 'company', id };
	}
	if (name === 'contact' || name.startsWith('contact.')) {
		return { type: 'contact', id };
	}
	return null;
}

export function useCreateActionContext(): CreateActionContext | undefined {
	const route = readRouteContext();
	const [resolved, setResolved] = useState<CreateActionContext | undefined>(undefined);

	useEffect(() => {
		if (!route) {
			setResolved(undefined);
			return;
		}
		let cancelled = false;
		const customerId = Tools.AppService.getCustomerId();
		const promise =
			route.type === 'company'
				? Tools.Account.customer(customerId)
						.get(route.id)
						.then(res => ({ type: 'company' as const, client: res.data }))
				: Tools.Contact.customer(customerId)
						.get(route.id)
						.then(res => ({ type: 'contact' as const, contact: res.data }));
		promise
			.then(context => {
				if (!cancelled) {
					setResolved(context);
				}
			})
			.catch(error => {
				console.error('useCreateActionContext: failed to resolve route context', error);
				if (!cancelled) {
					setResolved(undefined);
				}
			});
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [route?.type, route?.id]);

	if (!route) {
		return undefined;
	}
	const resolvedId = resolved?.type === 'company' ? resolved.client?.id : resolved?.contact?.id;
	if (resolved && resolvedId === route.id) {
		return resolved;
	}
	return route.type === 'company' ? { type: 'company' } : { type: 'contact' };
}
